import { Alert, Button, Snackbar } from "@mui/material";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import { useEffect, useState } from "react";
import { trackPromise } from "react-promise-tracker";
import { useNavigate } from "react-router-dom";
import { AUTHORIZATION, HOSTNAME_PATHI } from "../../../common/constants";
import HorizontalNav from "../../../components/HorizontalNav";
import authTokenForAPI from "../../../utils/authTokenForAPI";
import {
  primaryColor,
  secondaryColor,
  ternaryColor,
} from "../../../utils/styleObjs";

const ListShabad = () => {
  const [listShabad, setListShabad] = useState([]);
  const [listShabadMedia, setListShabadMedia] = useState([]);
  const [snack, setSnack] = useState({
    open: false,
    severity: "success",
    msg: "",
  });
  const history = useNavigate();
  useEffect(() => {
    trackPromise(
      axios
        .get(`${HOSTNAME_PATHI}/shabads`, {
          headers: { [AUTHORIZATION]: authTokenForAPI() },
        })
        .then((res) => {
          console.log(res);
          setListShabad(
            res.data.map((v) => ({
              ...v,
              id: v.ref,
              // shabadMedia: v.shabadMedia?.shabadMediaGroup,
            }))
          );
        })
    );
    trackPromise(
      axios
        .get(`${HOSTNAME_PATHI}/shabadMedias`, {
          headers: { [AUTHORIZATION]: authTokenForAPI() },
        })
        .then((res) => {
          console.log(res);
          setListShabadMedia(res.data.map((v) => ({ ...v, id: v.ref })));
        })
    );
  }, []);
  const navLinks = [{ key: 0, label: "Home", path: "/home" }];
  const columns = [
    { field: "ref", headerName: "ID" },
    {
      field: "shabadMedia",
      headerName: "Media Type",
      width: 150,
      valueGetter: (params) =>
        listShabadMedia.find((v) => v.ref === params.row.shabadMediaRef)
          ?.shabadMediaGroup,
    },
    { field: "shabad", headerName: "Shabad Name", width: 150 },
    { field: "satsandNumber", headerName: "Satsang Number", width: 150 },
    { field: "shabad", headerName: "Shabad Name", width: 150 },
    { field: "bani", headerName: "Bani", width: 150 },
    { field: "book", headerName: "Book", width: 150 },
    { field: "page", headerName: "Page", width: 150 },
    { field: "duration", headerName: "Duration", width: 150 },
  ];

  return (
    <>
      <Snackbar
        open={snack.open}
        autoHideDuration={6000}
        onClose={() => setSnack({ ...snack, open: false })}
      >
        <Alert
          elevation={6}
          variant="filled"
          onClose={() => setSnack({ ...snack, open: false })}
          severity={snack.severity}
          sx={{ width: "100%" }}
        >
          {snack.msg}
        </Alert>
      </Snackbar>
      <HorizontalNav navLinks={navLinks} pageName="Shabads" />
      <Box display={"flex"} justifyContent={"space-between"}>
        <h2>Shabads</h2>
        <Button
          variant="contained"
          sx={{
            margin: "20px",
            float: "right",
          }}
          onClick={() => history("/shabad/add")}
        >
          Add Shabad
        </Button>
      </Box>
      <div>
        <DataGrid
          density="compact"
          showCellRightBorder
          autoHeight
          sx={{
            borderColor: primaryColor,
            backgroundColor: ternaryColor,
            "& .MuiDataGrid-row:nth-of-type(odd)": {
              backgroundColor: secondaryColor,
            },
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: primaryColor,
              color: "white",
              fontWeight: "600",

              "& .MuiSvgIcon-root": {
                color: "white",
              },
            },
            "& .MuiDataGrid-cellCheckbox .MuiSvgIcon-root": {
              color: primaryColor,
            },
          }}
          onRowClick={(v) => {
            console.log(v);
            history(`/shabad/edit/${v.id}`);
          }}
          rows={listShabad}
          columns={columns}
        />
      </div>
    </>
  );
};
export default ListShabad;
